import { useState, createContext } from 'react'
import { loginCheck } from 'utils/general'

export const GlobalContext = createContext()

export const GlobalContextProvider = (props) => {
  const { children } = props

  // const [currentUser, setCurrentUser] = useState({})
  // const [isLoading, setIsLoading] = useState(true)
  const [isLogin, setIsLogin] = useState(loginCheck())
  const [loginCallBack, setLoginCallBack] = useState(false)
  const [serviceDialog, setServiceDialog] = useState({})
  const [multipleApplyDialog, setMultipleApplyDialog] = useState()
  const [applyCountDown, setApplyCountDown] = useState(0)
  const [jobSearchLoading, setJobSearchLoading] = useState(false)
  const [jobSearchDetailLoading, setJobSearchDetailLoading] = useState(false)
  const [gtmLoaded, setGtmLoaded] = useState(false)
  const [actionLoading, setActionLoading] = useState(false)

  const setOnlogin = (value) => {
    setIsLogin(value)
    if (value) setLoginCallBack(value)
  }

  const value = {
    // currentUser,
    // isLoading,
    // setCurrentUser,
    // setIsLoading,

    isLogin,
    setOnlogin,
    loginCallBack,
    setLoginCallBack,
    serviceDialog,
    setServiceDialog,
    multipleApplyDialog,
    setMultipleApplyDialog,
    applyCountDown,
    setApplyCountDown,
    jobSearchLoading,
    setJobSearchLoading,
    jobSearchDetailLoading,
    setJobSearchDetailLoading,
    gtmLoaded,
    setGtmLoaded,
    actionLoading,
    setActionLoading,
  }

  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  )
}
